import React from "react";

type StatusBallProps = {
    open: boolean;
}

export default class StatusBall extends React.Component<StatusBallProps> {
    renderOpen () {
        return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.9987 14.6673C11.6806 14.6673 14.6654 11.6825 14.6654 8.00065C14.6654 4.31875 11.6806 1.33398 7.9987 1.33398C4.3168 1.33398 1.33203 4.31875 1.33203 8.00065C1.33203 11.6825 4.3168 14.6673 7.9987 14.6673Z" fill="#31AC0D"/>
            <path d="M11 6.5L7.02941 10L5 8.5" stroke="white" strokeWidth="1.3" strokeLinecap="round"/>
        </svg>
    }

    renderClosed() {
        return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.9987 14.6673C11.6806 14.6673 14.6654 11.6825 14.6654 8.00065C14.6654 4.31875 11.6806 1.33398 7.9987 1.33398C4.3168 1.33398 1.33203 4.31875 1.33203 8.00065C1.33203 11.6825 4.3168 14.6673 7.9987 14.6673Z" fill="#E10003"/>
        <path d="M10 6L6 10" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6 6L10 10" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    }

    render() {
        if (this.props.open === true) return this.renderOpen();
        return this.renderClosed();
    }
}